import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
// 导入全局配置文件
import './plugins'
// 全局API
import API from '@/api'
// 登录检测
import '@/permission'
import ElementUI from 'element-ui'
// 全球化
import i18n from '@/i18n'
import { syncDocumentLang, getFormLabelWidth } from '@/utils/formLabelWidth'
// 全局自定义样式
import '@/css/global.scss'
import '@/css/revision.css'
import '@/css/font.scss'
import * as echarts from 'echarts'
// import '@/styles/element-variables.scss'
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.prototype.$bus = new Vue()
Vue.prototype.$echarts = echarts
Vue.prototype.$API = API
Vue.config.productionTip = false

Vue.mixin({
  methods: {
    formLabelWidth (size = 'default') {
      return getFormLabelWidth(size, this.$i18n.locale)
    }
  }
})

syncDocumentLang(i18n.locale)

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

app.$bus.$on('lang', (lang) => {
  syncDocumentLang(lang || i18n.locale)
})
